export class WebPushBrowserUIDModel {
    token: string;
    needToCheck: boolean;
}